import { createContext, useContext, useMemo, useState, useCallback } from "react";

const GestorPartidasNavContext = createContext(null);

export function GestorPartidasNavProvider({ children }) {
  const [nav, setNavState] = useState(null);
  const setGestorSidebarNav = useCallback((v) => {
    setNavState(v ?? null);
  }, []);
  const value = useMemo(
    () => ({ nav, setGestorSidebarNav }),
    [nav, setGestorSidebarNav],
  );
  return (
    <GestorPartidasNavContext.Provider value={value}>
      {children}
    </GestorPartidasNavContext.Provider>
  );
}

export function useGestorPartidasNav() {
  const ctx = useContext(GestorPartidasNavContext);
  if (!ctx) {
    throw new Error("useGestorPartidasNav requiere GestorPartidasNavProvider");
  }
  return ctx;
}

export function useGestorPartidasNavOptional() {
  return useContext(GestorPartidasNavContext);
}
